import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "../components/Logo";
import { ChevronLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#FFFAF5] py-8 px-4" data-testid="terms-page">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <Link to="/" className="flex items-center gap-2 text-[#FF7A29] hover:text-black text-sm">
            <ChevronLeft className="w-4 h-4"/> Home
          </Link>
          <LogoMark className="w-9 h-9"/>
        </div>
        <article className="bg-white border border-black rounded-3xl p-8 md:p-12">
          <div className="text-xs uppercase tracking-widest text-[#757575] mb-2">Versione 1.0 · 17 Maggio 2026</div>
          <h1 className="font-display text-4xl mb-6">Termini di Servizio</h1>

          <Section title="1. Oggetto">
            <p>Tool Badge fornisce una piattaforma SaaS multi-tenant per la gestione delle risorse umane (presenze, ferie, rimborsi, commesse, documenti firmati, payroll).</p>
          </Section>

          <Section title="2. Account">
            <p>L'utente è responsabile della riservatezza delle proprie credenziali. È vietato condividere l'account o consentire l'uso a terzi. In caso di sospetto accesso non autorizzato è obbligatorio cambiare password e segnalarlo a <a href="mailto:support@toolbadge.it" className="text-[#FF7A29]">support@toolbadge.it</a>.</p>
          </Section>

          <Section title="3. Uso lecito">
            <p>L'utente si impegna a utilizzare il servizio:</p>
            <ul>
              <li>Rispettando la normativa applicabile, inclusi GDPR e Statuto dei Lavoratori (L. 300/1970)</li>
              <li>Senza violare diritti di terzi (privacy, proprietà intellettuale)</li>
              <li>Senza tentare di compromettere la sicurezza o l'integrità della piattaforma</li>
            </ul>
          </Section>

          <Section title="4. Geolocalizzazione e timbrature">
            <p>La geolocalizzazione viene rilevata <strong>solo al momento del check-in QR</strong>, mai in modo continuo. L'utente può rifiutare il permesso GPS — in tal caso può inserire manualmente la propria posizione, ma il check-in sarà segnalato come "anomalo".</p>
          </Section>

          <Section title="5. Piani e fatturazione">
            <p>I piani sono mensili o annuali. La fatturazione è gestita da Stripe. In caso di mancato pagamento la company viene messa in stato "trial scaduto" dopo 14 giorni di grazia, poi disabilitata. I dati restano comunque conservati per 90 giorni per consentire la riattivazione.</p>
          </Section>

          <Section title="6. Disponibilità del servizio">
            <p>Tool Badge garantisce un SLA di uptime del 99,5% calcolato su base annua. Sono escluse manutenzioni programmate (comunicate con 48h di preavviso) e cause di forza maggiore.</p>
          </Section>

          <Section title="7. Limitazione di responsabilità">
            <p>Tool Badge non risponde di danni indiretti, perdita di profitti o di dati causati da uso improprio o cause esterne (es. provider terzi). Il limite massimo di responsabilità per anno è pari al corrispettivo annuo del servizio.</p>
          </Section>

          <Section title="8. Recesso">
            <p>L'utente può recedere in qualsiasi momento dalla sezione <em>Profilo → Abbonamento</em>. Il rimborso pro-rata è previsto solo per i piani annuali entro i primi 14 giorni.</p>
          </Section>

          <Section title="9. Modifiche">
            <p>Tool Badge può modificare i presenti termini con preavviso di 30 giorni via email. Il proseguimento dell'uso costituisce accettazione.</p>
          </Section>

          <Section title="10. Legge applicabile">
            <p>I presenti termini sono regolati dalla legge italiana. Foro competente: Roma.</p>
          </Section>

          <p className="text-xs text-[#757575] mt-8">Contatti: <a href="mailto:legal@toolbadge.it" className="text-[#FF7A29]">legal@toolbadge.it</a></p>
        </article>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="mt-6">
      <h2 className="font-display text-2xl text-[#FF7A29] mb-3">{title}</h2>
      <div className="text-sm text-[#333] leading-relaxed space-y-2">{children}</div>
    </div>
  );
}
